import React from 'react';
import './ProgressBar.css'; // Importa il file CSS per la ProgressBar

/**
 * ProgressBar Component.
 * Visualizza una barra di progresso per una skill specifica.
 *
 * @param {object} props - Component props.
 * @param {string} props.skill - Il nome della skill (es. "C++").
 * @param {number} props.percentage - La percentuale di progresso (0-100).
 * @param {string} [props.color='#00FFFF'] - Il colore di riempimento della barra (default azzurro).
 */
function ProgressBar({ skill, percentage, color = '#00FFFF' }) {
    // Clampa la percentuale tra 0 e 100 per sicurezza
    const clampedPercentage = Math.max(0, Math.min(100, percentage));

    return (
        <div className="progress-bar-container">
            <div className="progress-bar-label">
                <span className="skill-name">{skill}</span>
                <span className="percentage-value">{clampedPercentage}%</span>
            </div>
            <div className="progress-bar-bg">
                <div
                    className="progress-bar-fill"
                    style={{ width: `${clampedPercentage}%`, backgroundColor: color }}
                ></div>
            </div>
        </div>
    );
}

export default ProgressBar;
